import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import Mixin from './mixin';
let AmPopupContainer = class AmPopupContainer extends Mixins(Mixin) {
  get popoverWidth() {
    return this.width ? this.width.split('px')[0] : this.width;
  }
};
AmPopupContainer.componentName = 'AmPopupContainer';
AmPopupContainer = __decorate([Component({
  name: 'AmPopupContainer'
})], AmPopupContainer);
export default AmPopupContainer;